<template>
  <div>
    <vs-popup :title="titlePopup + $t('Branch')" :active.sync="showModal">
      <form>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.companyName"
              name="name"
              :label="$t('CompanyName')"
              v-validate="{
                required: 'true',
                min: '2',
                max: '150',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{
              errors.first("name")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.agentOwnerName"
              name="owner"
              :disabled="typePopup == 'edit'"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '10',
                max: '15',
              }"
              :label="$t('AgentOwnerNumber') + ' (نام کاربری)'"
            />
            <span class="text-danger text-sm" v-show="errors.has('owner')">{{
              errors.first("owner")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phoneModel in model.agentPhonesCommand"
              :key="phoneModel.id"
              v-model="phoneModel.area"
              name="area"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '3',
                max: '6',
              }"
              :label="$t('PhoneArea')"
            />
            <span class="text-danger text-sm" v-show="errors.has('area')">{{
              errors.first("area")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phoneModel in model.agentPhonesCommand"
              :key="phoneModel.id"
              v-model="phoneModel.number"
              name="number"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '5',
                max: '11',
              }"
              :label="$t('PhoneNumber')"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.emailAddress"
              name="email"
              v-validate="{
                required: 'true',
                email: 'true',
                max: '150',
              }"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1 mt-1">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvinces"
              name="province"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              :reduce="(x) => ({ provinceId: x.id, provinceName: x.name })"
              v-validate="{ required: 'true' }"
              ref="provinceListSelect"
              class="mb-4"
              v-model="address.agentProvinceInfo"
              @input="selectProvince"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('province')">{{
              errors.first("province")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1 mt-1">
            <label class="vs-select--label mt-4">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="city"
              :options="allCities"
              :reduce="(x) => ({ cityId: x.id, cityName: x.name })"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.agentCityInfo"
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityListSelect"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{
              errors.first("city")
            }}</span>
          </div>
          <div class="vx-col md:w-1/3 sm:w-1/2 w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.postalCode"
              name="postalCode"
              v-validate="{
                required: 'true',
                regex: '^([0-9]+)$',
                digits: '10',
              }"
              :label="$t('PostalCode')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('postalCode')"
              >{{ errors.first("postalCode") }}</span
            >
          </div>
          <div class="vx-col w-full px-1">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.address"
              name="address"
              :label="$t('Address')"
              v-validate="{
                required: 'true',
                min: '3',
                max: '500',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')">{{
              errors.first("address")
            }}</span>
          </div>
        </div>

        <div class="vx-col w-full my-2">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitForm()"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    name: {
      required: "لطفا نام شرکت را وارد نمایید.",
      regex: "نام شرکت وارد شده معتبر نیست.",
      max: "نام شرکت وارد شده معتبر نیست.",
      min: "نام شرکت وارد شده معتبر نیست.",
    },
    owner: {
      required: "لطفا شماره موبایل مالک اصلی را وارد نمایید.",
      regex: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      max: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      min: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
    },
    area: {
      required: "لطفا پیش شماره را وارد نمایید.",
      regex: "پیش شماره وارد شده معتبر نیست.",
      max: "پیش شماره وارد شده معتبر نیست.",
      min: "پیش شماره وارد شده معتبر نیست.",
    },
    number: {
      required: "لطفا شماره تلفن را وارد نمایید.",
      regex: "شماره تلفن وارد شده معتبر نیست.",
      max: "شماره تلفن وارد شده معتبر نیست.",
      min: "شماره تلفن وارد شده معتبر نیست.",
    },
    email: {
      required: "لطفا پست الکترونیک را وارد نمایید.",
      email: "پست الکترونیک وارد شده معتبر نیست.",
      max: "پست الکترونیک وارد شده معتبر نیست.",
    },
    province: {
      required: "لطفا استان را انتخاب نمایید.",
    },
    city: {
      required: "لطفا شهر را انتخاب نمایید.",
    },
    postalCode: {
      required: "لطفا کدپستی را وارد نمایید.",
      regex: "کدپستی وارد شده معتبر نیست.",
      digits: "کدپستی وارد شده معتبر نیست.",
    },
    address: {
      required: "لطفا آدرس را وارد نمایید.",
      max: "شماره تلفن وارد شده معتبر نیست.",
      min: "شماره تلفن وارد شده معتبر نیست.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    currentBranchData: {
      default: {},
    },
    agentParentId: {
      default: "",
    },
    typePopup: {
      default: "",
    },
  },
  data() {
    return {
      titlePopup: "",
      modelEdit: {},
      model: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCities: "country/cityList",
    }),
  },
  methods: {
    ...mapActions({
      createBranch: "legal/createBranch",
      editBranch: "legal/editBranch",
      fetchProvinces: "country/fetchProvinces",
      fetchCitiesById: "country/fetchCitiesById",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.typePopup == "edit") {
            this.modelEdit = {
              id: this.currentBranchData.id,
              emailAddress: this.model.emailAddress,
              addressesInfoCommand: this.model.addressesInfoCommand,
              agentPhonesCommand: this.model.agentPhonesCommand,
              companyName: this.model.companyName,
            };
            this.editBranch(this.modelEdit)
              .then(() => {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {
                  this.model = {};
                  this.$emit("finish");
                });
                this.$validator.reset();
              })
              .catch(() => {});
          } else {
            this.model.agentIdWhoHasBranch = this.$route.params.id;
            this.createBranch(this.model)
              .then(() => {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {
                  this.model = {};
                  this.$emit("finish");
                });
                this.$validator.reset();
              })
              .catch(() => {});
          }
        }
      });
    },
    selectProvince(province) {
      this.$refs.cityListSelect = [];
      this.fetchCitiesById(province.provinceId);
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.typePopup == "edit") {
          this.fetchProvinces().then(() => {});
          // Only set for one address, province and city
          this.titlePopup = "ویرایش ";
          this.selectProvince(
            this.currentBranchData.addressInfo[0].agentProvinceInfo,
          );
          this.model = {
            emailAddress: this.currentBranchData.emailAddress,
            agentOwnerName:
              this.currentBranchData.agentOwnerQuery.agentOwnerName,
            addressesInfoCommand: this.currentBranchData.addressInfo,
            agentPhonesCommand: this.currentBranchData.agentPhones,
            companyName: this.currentBranchData.companyName,
          };
        } else {
          this.titlePopup = "افزودن ";
          this.model = {
            emailAddress: "",
            agentOwnerName: "",
            addressesInfoCommand: [
              {
                agentProvinceInfo: {
                  provinceId: 0,
                  provinceName: "",
                },
                agentCityInfo: {
                  cityId: 0,
                  cityName: "",
                },
                address: "",
                postalCode: "",
              },
            ],
            agentPhonesCommand: [
              {
                area: "",
                number: "",
              },
            ],
            agentIdWhoHasBranch: 0,
            companyName: "",
          };
          this.fetchProvinces();
        }
      }
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>

<style></style>
